import React from 'react';
import { SolutionPage } from '../../components/solutions/SolutionPage';
import { SolutionDepthSection } from '../../components/solutions/SolutionDepthSection';
export function CivilSocietyPage() {
  return <SolutionPage id="community" data-id="element-2781" data-mp="3hgeh7ihr8zjr">
      <SolutionDepthSection id="community" data-id="element-2782" data-mp="3hfd3t7d9o0yv" />
    </SolutionPage>;
}